import { motion } from "framer-motion";
import { PROCESS } from "./data";

const PROCESS_IMG =
  "https://images.unsplash.com/photo-1758691461990-03b49d969495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwcHJvZmVzc2lvbmFscyUyMGNvbnN1bHRhdGlvbiUyMG9mZmljZXxlbnwwfHx8fDE3ODUzNTMyNTF8MA&ixlib=rb-4.1.0&q=85";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-28 md:py-40 bg-primary text-primary-foreground">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-primary-foreground/60">The method</span>
            <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none">
              Four disciplined chapters to in-network.
            </h2>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="mt-12 overflow-hidden rounded-sm hidden lg:block"
            >
              <img src={PROCESS_IMG} alt="Enrollment specialist reviewing provider credentials" className="w-full h-[360px] object-cover grayscale-[15%]" />
            </motion.div>
          </div>

          <div className="lg:col-span-7 lg:pl-8">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.no}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.05, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 border-t border-primary-foreground/15 first:border-t-0"
                data-testid={`process-step-${i}`}
              >
                <span className="font-serif text-5xl md:text-7xl font-light text-primary-foreground/30 leading-none">{p.no}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight">{p.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-primary-foreground/70 leading-relaxed max-w-lg">{p.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
